import { render, staticRenderFns } from "./TwTableCell.vue?vue&type=template&id=35924836&scoped=true&"
import script from "./TwTableCell.vue?vue&type=script&lang=js&"
export * from "./TwTableCell.vue?vue&type=script&lang=js&"
import style0 from "./TwTableCell.vue?vue&type=style&index=0&id=35924836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35924836",
  null
  
)

export default component.exports